<template>
  <div class="warning-block">
    <div class="text" v-if="$resize && $mq.below(1439)">ИМЕЮТСЯ ПРОТИВОПОКАзания.<br>ознакомьтесь с инструкцией.</div>
    <div class="text text-width" v-if="$resize && $mq.above(1440)">ИМЕЮТСЯ ПРОТИВОПОКАзания. ознакомьтесь с инструкцией.</div>


  </div>
</template>

<script>
export default {
  name: "WarningBlock"
};
</script>

<style scoped lang="scss">
.warning-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scaleY(2.3543);
  margin-top: 10vmax;
  .text {
    text-transform: uppercase;
    color: #c7c7c7;
    font-size: 6vw;
    font-weight: 100;
    line-height: 6vw;
    text-align: center;
    min-height: 67px;
    /* transform: scaleY(2.3543); */
    overflow: hidden;
    margin: 0;
    &.text-width {
      font-size: 3vw;
      line-height: 4vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WarningBlock.vue